import tinycolor from 'tinycolor2';

const primary = '#536DFE';
const secondary = '#EE266D';
const warning = '#E9B55F';
const success = '#63C5B5';
const info = '#AE1ECC';
const lightenRate = 7.5;
const darkenRate = 15;

export default {
  palette: {
    contrastText: '#fff',
    type: 'dark',
    primary: {
      main: primary,
      light: tinycolor(primary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(primary)
        .darken(darkenRate)
        .toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(secondary)
        .darken(darkenRate)
        .toHexString(),
      contrastText: '#fff',
    },
    warning: {
      main: warning,
      light: tinycolor(warning)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(warning)
        .darken(darkenRate)
        .toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(success)
        .darken(darkenRate)
        .toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info)
        .lighten(lightenRate)
        .toHexString(),
      dark: tinycolor(info)
        .darken(darkenRate)
        .toHexString(),
    },
    inherit: {
      main: 'inherit',
      light: tinycolor('inherit')
        .lighten('inherit')
        .toHexString(),
      dark: tinycolor('inherit')
        .darken('inherit')
        .toHexString(),
    },
    text: {
      primary: '#fff',
      secondary: '#D6D6D6',
      hint: '#D6D6D6',
    },
    background: {
      default: '#13131A',
      light: '#23232D',
    },
  },
  customShadows: {
    widget:
            '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetDark:
            '0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    widgetWide:
            '0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
  },
};
